<template>
  <div :class="{ 'lego-list': items.length > 0 }">
    <slot>
      <template v-for="(item, idx) in items" :key="idx">
        <div class="lego-list__box">
          <div class="lego-list__box__title">{{ item.title }}</div>
          <div class="lego-list__box__header">{{ item.header }}</div>
          <div class="lego-list__box__info">{{ item.info }}</div>
        </div>
      </template>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'legoList',
  props: {
    items: { type: Array, default: () => [] },
  },
};
</script>

<style lang="scss" scoped>
.lego-list {
  border-top: 1px solid $color--ui-06;
  border-bottom: 1px solid $color--ui-06;
  padding-bottom: 8px;
  &__box {
    padding: 0 24px 16px 24px;
    margin-bottom: 16px;
    border-bottom: 1px solid $color--ui-07;

    &:nth-of-type(1) {
      padding-top: 16px;
    }

    &:nth-last-child(1) {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    &__title {
      @include font(14px, 500);
      color: $color--ui-02;
      margin-bottom: 8px;
    }

    &__header {
      @include font(13px);
      color: $color--ui-04;
    }

    &__info {
      @include font(13px);
      color: $color--ui-04;
    }
  }
}
</style>
